import React from 'react';
import Select from 'react-select';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';
import sortasc from '../../../img/sort-asc.svg';
import sortdesc from '../../../img/sort-desc.svg';
import check from '../../../img/check.svg';
import emptybox from '../../../img/emptybox.svg';



export default class EventParticipantSelectScreen extends React.Component {

    constructor(props) {
        super(props);

        var eventid = null
        var sortField = null
        var sortOrder = null
        var pageCount = 0
        var event = null
        
        const args = props.args === undefined ? {} : props.args

        if (args.event !== undefined) {
            event = args.event
        }

        if (args.eventid !== undefined) {
            eventid = args.eventid
        }

        if (args.pageCount !== undefined) {
            pageCount = args.pageCount
        }

        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        this.state = {args: args,
                      pageLimit: 25, 
                      pageCount: pageCount,   
                      nameCriteria: "",
                      prevNameCriteria:"",
                      eventid: eventid,
                      event: event,
                      sortField: sortField, 
                      sortOrder: sortOrder,
                      beneficiaries: [],
                      selected: []};

              

        this.nameSearch = this.nameSearch.bind(this);  
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this);  
        this.sortClicked = this.sortClicked.bind(this)

        setTimeout(this.nameSearch, 2000);
    }

    async componentDidMount() {
        this.getDataWithCritera()
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }


    getDataWithCritera() {

        var parameters = {}

        if (this.state.eventid) {
            parameters.eventid = this.state.eventid
        } 

        if (this.state.event.institutionid) {
            parameters.instituteid = this.state.event.institutionid
        } 

        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        parameters.limit = this.state.pageLimit
        parameters.offset = this.state.pageLimit * this.state.pageCount

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

        BaseApi.get('/event/participant/select', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({beneficiaries: res.data})
        })    
        .catch(error=>console.log(error))
    }

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCritera)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    nextPage() {
        var args = this.state.args
        args.pageCount = this.state.pageCount + 1
        this.setState({pageCount: this.state.pageCount + 1}, this.getDataWithCritera)
    }

    prevPage() {
        if (this.state.pageCount > 0) {
            var args = this.state.args
            args.pageCount = this.state.pageCount - 1
            this.setState({pageCount: this.state.pageCount - 1, args: args}, this.getDataWithCritera)
        }
    }

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break 
            case "yearofbirthCaption" :
                if (currentField === "yearofbirth") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "yearofbirth"
                    currentOrder = "asc"
                }
            break           
        }
        var args = this.state.args
        args.pageCount = 0
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder, pageCount: 0}, this.getDataWithCritera)
    }

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 

    save() {
        BaseApi.post('/event/participant', this.state.selected, {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
    }

    switchSelected(id) {
        var selected = this.state.selected

        if (this.isSelected(id)) {
            selected = selected.filter(item => item.beneficiaryid !== id)
        } else {
            selected.push({beneficiaryid: id, eventid: this.state.eventid})
        }

        this.setState({selected: selected})
    }

    isSelected(id) {
        return this.state.selected.filter(item => item.beneficiaryid === id).length > 0
    }
    
    renderBeneficiary(beneficiary) {
    
        return (
            <tr key={beneficiary.id}>
                <td style={{textAlign: 'left',  padding: '4px'}}>{beneficiary.name}</td>
                <td>{beneficiary.yearofbirth}</td>
                <td   
                    onClick={()=>{this.switchSelected(beneficiary.id)}}
                >
                    {this.isSelected(beneficiary.id) && <img src={check} height="16" width="16"/>}
                    {!this.isSelected(beneficiary.id) && <img src={emptybox} height="16" width="16"/>}
                </td>
            </tr>
        )        
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Добавить участников к событию"}/>
                {/* Фильтр + кнопка добавления + пагинация */}
                <div className="row mt-4 mb-3">
                    <div className="col-lg-6">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Фильтр</h6>

                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Имя</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        value={this.state.nameCriteria}
                                        onChange={this.nameCriteriaChangeHandler}
                                        placeholder="Введите ФИО или часть имени"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 d-flex flex-column align-items-end mt-3 mt-lg-0">
                        <div className="mb-2">
                            <button
                                type="button"
                                className="btn btn-primary d-flex align-items-center"
                                onClick={() => this.save()}
                            >
                                Сохранить
                            </button>
                        </div>

                        <div>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm me-2"
                                onClick={() => this.prevPage()}
                                disabled={this.state.pageCount === 0}
                            >
                                Предыдущие
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => this.nextPage()}
                            >
                                Следующие
                            </button>
                        </div>
                    </div>
                </div>
             
                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <table className="table table-sm table-hover mb-0 align-middle">
                            <thead className="table-primary">
                                <tr>
                                     <th
                                        id="nameCaption"
                                        style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                        onClick={this.sortClicked}
                                    >    
                                        ФИО{" "}
                                        {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                                        {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                                     </th>
                                      <th 
                                        id="yearofbirthCaption" 
                                        style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                        onClick={this.sortClicked}>
                                        Год рождения{" "}
                                        {this.isFieldSortedDesc("yearofbirth") && <img src={sortdesc} height="16" width="16"/>}
                                        {this.isFieldSortedAsc("yearofbirth") && <img src={sortasc} height="16" width="16"/>}
                                    </th>
                                    <th 
                                        id="detailCaptuon" 
                                        style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                    >
                                        Выбор
                                    </th>  
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.beneficiaries.map((value, index) => this.renderBeneficiary(value))}
                            </tbody>
                        </table>
                    </div>
                </div>    
                
            
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/event/participant-select.js